import { Directive, HostBinding } from '@angular/core';
import { clsx } from 'clsx';

@Directive({
  selector: '[chapterTitle]',
})
export class ChapterTitleDirective {
  @HostBinding('class')
  hostClasses = clsx('m-0 text-3xl font-extrabold');
}
